export default "__VITE_ASSET__CEDcb6WB__"